import PropTypes from 'prop-types';
import clsx from 'clsx';
import Paragraph from '@/components/Paragraph';

const defaultProps = {
  muted: true,
  className: null,
};

const propTypes = {
  muted: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default function Lead({
  muted,
  className,
  children,
}) {
  return (
    <Paragraph className={clsx('text-lg lg:text-xl font-normal leading-normal', muted && 'text-gray-600', className)}>
      {children}
    </Paragraph>
  );
}

Lead.defaultProps = defaultProps;
Lead.propTypes = propTypes;
